import { useEffect, useState } from 'react';
import axios from '../../../lib/axios';
import Loading from '../../../components/Loading';
import { useParams } from 'react-router';

const PhoneConfirmation = () => {
    const [loading, setLoading] = useState(true);
    const { challenge } = useParams();

    useEffect(() => {
        axios
            .put('users/validate_phone_number', {
                challenge,
            })
            .then(() => {
                setLoading(false);
            });
    }, [challenge]);

    return (
        <div>
            {loading && <Loading />}
            {!loading && (
                <div className="flex flex-col items-center justify-center h-screen">
                    <h1>Félicitations, votre numéro de téléphone a bien été validé !</h1>
                    <p>Vous pouvez maintenant accéder à votre compte et utiliser la conversation Whatsapp associée</p>
                </div>
            )}
        </div>
    );
};

export default PhoneConfirmation;
